/* eslint-disable @typescript-eslint/no-var-requires */
/**
 * The main app bundle responsible for app configuration and client-side rendering.
 */
import 'quartz/framework/set-http-labs';
import rhumbConfig from '$host-package-base-dir/rhumb-config.yaml';
import { i18nSetup } from '../internal/i18n/i18nSetup';
import { mark } from '../internal/perf';
import { getQuartzConfig } from 'quartz-config/evaluable';
import { renderApp } from '../internal/app-renderer';
import { initTracing } from 'opentelemetry-fe';
import { getCurrentPackageName } from 'quartz/framework/environment/service';
import { invariant } from 'quartz/invariant';
const quartzConfig = getQuartzConfig();
/* invariant(quartzConfig.type === 'application') */
;
mark('quartz.appEntry');

// @bend-expect module-level-quartz-call
const appName = getCurrentPackageName();
void initTracing(appName, Object.assign({
  instrumentFetch: true,
  instrumentXhr: true,
  instrumentQuickFetch: true
}, quartzConfig.otel));
const lang = i18nSetup();
if ( /* quartzConfig.legacy_setupGeneralStore */false) {
  require('../internal/setup-general-store');
}
const App = require('$host-package-base-dir/js/+app');
if (process.env.NODE_ENV !== 'production') {
  if (typeof App.AppComponent === 'undefined') {
    throw new Error('Did you forget to export `AppComponent` from `+app.tsx`?');
  }
  if (typeof App.prepareApp !== 'function') {
    throw new Error('Did you forget to export or `prepareApp` from `+app.tsx`?');
  }
}
const {
  adapter
} = require(`../internal/adapters/${/* quartzConfig.auth */"none"}-auth-adapter`);
renderApp(App, {
  rhumbConfig,
  lang,
  adapter
}).catch(err => {
  setTimeout(() => {
    throw err;
  });
});